var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForwardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_ios_FILL0_wght300_GRAD0_opsz24 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.8874 8.00063L4.8656 2.97883C4.73313 2.84636 4.66859 2.68867 4.672 2.50577C4.67543 2.32286 4.74338 2.16517 4.87585 2.0327C5.00833 1.90022 5.16602 1.83398 5.34892 1.83398C5.53182 1.83398 5.68951 1.90022 5.82199 2.0327L10.9258 7.1468C11.0463 7.26731 11.1357 7.40235 11.1938 7.55192C11.2519 7.7015 11.281 7.85107 11.281 8.00063C11.281 8.1502 11.2519 8.29977 11.1938 8.44935C11.1357 8.59892 11.0463 8.73396 10.9258 8.85447L5.81174 13.9686C5.67926 14.101 5.52328 14.1656 5.34379 14.1622C5.16431 14.1587 5.00833 14.0908 4.87585 13.9583C4.74338 13.8258 4.67714 13.6682 4.67714 13.4853C4.67714 13.3024 4.74338 13.1447 4.87585 13.0122L9.8874 8.00063Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardWhite);
export default __webpack_public_path__ + "static/media/arrow-forward-white.102ca33299044fb0468d3bde3d10c26a.svg";
export { ForwardRef as ReactComponent };